import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const serviceGroups = [
  {
    id: "automation",
    tabLabel: "Automation & Agentic AI",
    title: "Automation & Agentic AI",
    subtitle: "Agents that deliver outcomes",
    categoryLink: "/automation-and-ai-agents",
    services: [
      {
        id: 1,
        title: "Conversational AI",
        link: "/conversationalai",
        image: "/assets/what/item1.png",
        isBanner: true,
      },
      {
        id: 2,
        title: "Machine Learning & ML Ops",
        link: "/machine-learning-mlops",
        image: "/assets/what/item2.png",
        isBanner: true,
      },
      {
        id: 3,
        title: "Generative AI & LLM",
        link: "/generative-ai-llm",
        image: "/assets/what/item3.png",
        isBanner: true,
      },
      {
        id: 4,
        title: "AI & Automation",
        link: "/ai-automation",
        image: "/assets/what/item4.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 5,
        title: "Agentic AI Services",
        link: "/agentic-ai-services",
        image: "/assets/what/item5.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
    ],
  },
  {
    id: "servicenow",
    tabLabel: "ServiceNow",
    title: "ServiceNow",
    subtitle: "Agents that deliver outcomes",
    categoryLink: "/servicenow",
    services: [
      {
        id: 6,
        title: "ServiceNow Consulting",
        link: "/service/servicenow-consulting",
        image: "/assets/what/item7.png",
        isBanner: true,
      },
      {
        id: 7,
        title: "ServiceNow Implementation",
        link: "/service/servicenow-implementation",
        image: "/assets/what/item8.png",
        isBanner: true,
      },
      {
        id: 8,
        title: "ServiceNow ITSM",
        link: "/service/servicenow-itsm",
        image: "/assets/what/item9.png",
        isBanner: true,
      },
      {
        id: 9,
        title: "ServiceNow ITOM & CMDB",
        link: "/service/servicenow-itom-cmdb",
        image: "/assets/what/item10.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 10,
        title: "ServiceNow CSM",
        link: "/service/servicenow-csm",
        image: "/assets/what/item11.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 12,
        title: "ServiceNow AI & Automation",
        link: "/service/servicenow-ai-automation",
        image: "/assets/what/item13.png",
        isBanner: true,
      },
      {
        id: 11,
        title: "ServiceNow HRSD",
        link: "/service/servicenow-hrsd",
        image: "/assets/what/item12.png",
        isBanner: true,
        spanClass: "row-span-2 col-span-1 md:col-span-2 lg:col-span-2 min-h-[460px]",
      },
      {
        id: 13,
        title: "ServiceNow Integration",
        link: "/service/servicenow-integration",
        image: "/assets/what/item14.png",
        isBanner: true,
      },
      {
        id: 14,
        title: "ServiceNow Custom Development",
        link: "/service/servicenow-custom-development",
        image: "/assets/what/item6.png",
        isBanner: true,
      },
      {
        id: 15,
        title: "ServiceNow Managed Services",
        link: "/service/servicenow-managed-services",
        image: "/assets/what/item15.png",
        isBanner: true,
      },
      {
        id: 16,
        title: "ServiceNow Resource Augmentation",
        link: "/service/servicenow-resource-augmentation",
        image: "/assets/what/item16.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 17,
        title: "ServiceNow Center of Excellence (COE)",
        link: "/service/servicenow-coe",
        image: "/assets/what/c1.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
    ],
  },
  {
    id: "data-ai",
    tabLabel: "Data & AI Databricks",
    title: "Data & AI Databricks",
    subtitle: "Agents that deliver outcomes",
    categoryLink: "/data-ai-databricks-solution",
    services: [
      {
        id: 18,
        title: "Databricks Consulting & Implementation",
        link: "/data-analytics",
        image: "/assets/what/c2.png",
        isBanner: true,
        spanClass: "row-span-2 col-span-1 md:col-span-2 lg:col-span-2 min-h-[450px]",
      },
      {
        id: 19,
        title: "Lakehouse Architecture & Migration",
        link: "/data-analytics",
        image: "/assets/what/c3.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 20,
        title: "Data Engineering & Governance",
        link: "/data-analytics",
        image: "/assets/what/c4.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 21,
        title: "GenAI & Agents on Databricks",
        link: "/data-analytics",
        image: "/assets/what/c5.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 22,
        title: "Analytics, BI & Dashboards",
        link: "/data-analytics",
        image: "/assets/what/c7.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 23,
        title: "Databricks Managed Services",
        link: "/data-analytics",
        image: "/assets/what/c8.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
    ],
  },
  {
    id: "digital-engineering",
    tabLabel: "Digital Engineering",
    title: "Digital Engineering",
    subtitle: "Agents that deliver outcomes",
    categoryLink: "/digital-engineering",
    services: [
      {
        id: 24,
        title: "Product Engineering",
        link: "/product-engineering",
        image: "/assets/v/item16.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 25,
        title: "Performance Engineering",
        link: "/performance-engineering",
        image: "/assets/v/item19.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 26,
        title: "Cloud Engineering",
        link: "/cloud-engineering",
        image: "/assets/v/item18.png",
        isBanner: true,
        spanClass: "row-span-2 col-span-1 md:col-span-2 lg:col-span-2 min-h-[460px]",
      },
      {
        id: 27,
        title: "Data & Analytics",
        link: "/data-analytics",
        image: "/assets/v/item17.jpg",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 28,
        title: "Infor M3 Solutions",
        link: "/infor-m3-solutions",
        image: "/assets/v/item15.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 29,
        title: "Infor EPM Services",
        link: "/infor-epm-services",
        image: "/assets/v/item13.jpg",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 30,
        title: "Global Capability Centers",
        link: "/global-capability-centers",
        image: "/assets/v/item12.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 31,
        title: "MES Solutions",
        link: "/manufacturing-execution-system",
        image: "/assets/v/item9.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 32,
        title: "Industrial Automation",
        link: "/industrial-automation",
        image: "/assets/v/item8.jpg",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 33,
        title: "Embedded Services",
        link: "/embedded-services",
        image: "/assets/v/item7.jpg",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-2 lg:col-span-2",
      },
      {
        id: 34,
        title: "Staff Augmentation",
        link: "/staff-augmentation",
        image: "/assets/v/item6.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
      {
        id: 35,
        title: "Building Automation",
        link: "/building-automation-solutions",
        image: "/assets/work/img3.png",
        isBanner: true,
        spanClass: "col-span-1 md:col-span-3 lg:col-span-3",
      },
    ],
  },
];

const ServicesSection = () => {
  const [activeGroup, setActiveGroup] = useState(serviceGroups[0].id);

  const scrollToSection = (id) => {
    setActiveGroup(id);
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -90;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section className="w-full bg-white">
      <div className="w-full sticky top-[70px] lg:top-[100px] z-30 bg-white/95 backdrop-blur-md ">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-[80px] py-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 lg:gap-3">
            {serviceGroups.map((group) => {
              const isActive = activeGroup === group.id;

              return (
                <button
                  key={group.id}
                  onClick={() => scrollToSection(group.id)}
                  type="button"
                  className={`
                    relative min-h-[56px] lg:min-h-[64px]
                    px-3 sm:px-5 lg:px-6
                    flex items-center justify-center
                    text-center font-graphik
                    text-[13px] sm:text-[14px] lg:text-[16px]
                    font-medium leading-snug
                    transition-all duration-300 ease-in-out
                    cursor-pointer
                    ${
                      isActive
                        ? "bg-[#FFF6EF] text-[#ED6800] shadow-[0_3px_12px_rgba(237,104,0,0.08)]"
                        : "bg-[#F7F9FC] text-[#01386A] hover:bg-[#EEF3F8] hover:text-[#ED6800]"
                    }
                  `}
                >
                  {group.tabLabel}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Main Content Sections */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-[80px] pt-12 lg:pt-16">
        {serviceGroups.map((group) => (
          <div key={group.id} id={group.id} className="mb-10 lg:mb-16 scroll-mt-20">
            <div className="mb-8 lg:mb-10 text-left">
              <Link to={group.categoryLink} className="inline-block group/title">
                <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.25] group-hover/title:text-[#ED6800] transition-colors">
                  {group.title}
                </h2>
              </Link>
              <p className="font-graphik text-[14px] sm:text-[16px] text-[#49577A] font-[500] mt-2">
                {group.subtitle}
              </p>
            </div>

            {/* Bento Grid */}
            <div className="grid grid-cols-1 md:grid-cols-6 gap-5 lg:gap-6 items-stretch">
              {group.services.map((service) => {
                const defaultSpan = service.spanClass || "col-span-1 md:col-span-2 lg:col-span-2";

                if (service.isBanner) {
                  return (
                    <div
                      key={service.id}
                      className={`relative overflow-hidden group min-h-[220px] sm:min-h-[250px] p-7 lg:p-9 flex flex-col justify-between ${defaultSpan}`}
                    >
                      {/* Image Background */}
                      <img
                        src={service.image}
                        alt={service.title}
                        loading="lazy"
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                      {/* Dark Gradient Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-[#021B35]/95 via-[#021B35]/60 to-transparent" />

                      <div className="relative z-10">
                        <h3 className="font-sora text-[16px] lg:text-[20px] font-[600] text-white tracking-tight leading-[1.3] mb-3">
                          {service.title}
                        </h3>
                        <div className="w-[36px] h-[3px] bg-[#ED6800]" />
                      </div>

                      <div className="relative z-10 pt-6">
                        <Link
                          to={service.link}
                          className="inline-flex items-center gap-1.5 font-graphik text-[14px] lg:text-[16px] font-[500] text-white underline underline-offset-4 hover:text-[#ED6800] transition-colors"
                        >
                          Read More
                          <ChevronRight size={16} />
                        </Link>
                      </div>
                    </div>
                  );
                }

                // Standard Light Card
                return (
                  <div
                    key={service.id}
                    className={`bg-[#F2F5FF] p-7 lg:p-8 flex flex-col justify-between min-h-[210px] sm:min-h-[230px] group transition-all duration-300 hover:shadow-md ${defaultSpan}`}
                  >
                    <div>
                      <h3 className="font-sora text-[16px] lg:text-[20px] font-[600] text-[#01386A] tracking-tight leading-[1.3] mb-3">
                        {service.title}
                      </h3>
                        <div className="w-[36px] h-[3px] bg-[#ED6800]" />
                    </div>

                    <div className="pt-6">
                      <Link
                        to={service.link}
                        className="inline-flex items-center gap-1.5 font-graphik text-[14px] lg:text-[16px] font-[500] text-[#01386A] underline underline-offset-4 hover:text-[#ED6800] transition-colors"
                      >
                        Read More
                        <ChevronRight size={16} />
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;